import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "input-api-key" }
const _hoisted_2 = {
  key: 0,
  class: "tip bg-yellow-100 border border-yellow-300 text-yellow-700 px-4 py-3 rounded relative mt-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://platform.openai.com/account/api-keys",
  class: "font-bold underline ml-1 sm:ml-0",
  target: "_blank"
}, " the page ", -1)
const _hoisted_4 = {
  key: 1,
  class: "tip bg-yellow-100 border border-yellow-300 text-yellow-700 px-4 py-3 rounded relative mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.value && _ctx.showWarn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(" To get an API KEY you need to register new OPEN AI account (if you haven't) and then visit "),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.useLocalStorage && _ctx.showWarn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " The key will saved only in your browser "))
      : _createCommentVNode("", true),
    _createVNode(_component_InputText, {
      value: _ctx.value,
      type: "password",
      error: !_ctx.value,
      label: 'API Key:',
      class: "mt-2",
      "onUpdate:value": _cache[0] || (_cache[0] = (val) => (_ctx.$emit('update:value', val), _ctx.useLocalStorage && _ctx.ls(_ctx.localStorageKey, val))),
      placeholder: "Paste an API key here"
    }, null, 8, ["value", "error"])
  ]))
}